// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"aeab7f6a","769":"0e4896fc"}[chunkId] + ".chunk.js";
};